// ============================================
// P3 支付线（P-08 前端）：支付意图（全局）
// 组件面板/素材页等无 React 上下文的拦截点 → 触发全局支付弹窗
// 由 <PayDialogHost/> 统一渲染 PayDialog
// ============================================
import { create } from 'zustand';

export interface PayIntentInput {
  orderType: 'subscription' | 'plugin_component' | 'material' | 'addon' | 'license' | 'dtbase';
  packageId?: string;
  productRef?: string;
  /** ⑥License：目标设备序列号 */
  deviceSn?: string;
  /** DW-P1-4：部署项目授权（license 订单携带项目码） */
  projectCode?: string;
  amount?: number;
  subject?: string;
}

interface PayIntentState {
  open: boolean;
  input: PayIntentInput | null;
  onSuccess?: () => void;
  openPay: (input: PayIntentInput, onSuccess?: () => void) => void;
  closePay: () => void;
}

export const usePayIntentStore = create<PayIntentState>((set) => ({
  open: false,
  input: null,
  openPay: (input, onSuccess) => set({ open: true, input, onSuccess }),
  closePay: () => set({ open: false, input: null, onSuccess: undefined }),
}));
